module.exports = __webpack_public_path__ + "img/6-2management.cc847c95.png";